import { IColumnProps, IFilterableDataProps } from "../../interfaces/table";

import { SVGIcon } from "../wrappers/SVGIcon";
import { Checkbox } from "../reusables/FormElements";

import { getDateString } from "../../helpers/utility";

import { Icons } from "../../data/Assets";

interface FilterTableProps {
    columns: IColumnProps[];
    data: IFilterableDataProps[];
    enableFilters: boolean;
    filters: number[];
    setFilters: React.Dispatch<React.SetStateAction<number[]>>;
};

const FilterTable = (props: FilterTableProps) => {
    const { data, columns, filters, setFilters, enableFilters } = props;

    if (!data.length) return null;

    const keys = Object.keys(data[0]);

    const formatValue = (value: string | number | boolean | Date) => {
        if (typeof value === 'string') {
            return value;
        } else if (typeof value === 'number') {
            return value.toString();
        } else if (typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        } else if (value instanceof Date) {
            return getDateString(value);
        }
    };

    const isChecked = (id: number) => {
        return filters.includes(id);
    };

    const onHandleFilter = (id: number) => {
        if (isChecked(id)) {
            setFilters(filters.filter((filter) => filter !== id));
        } else {
            setFilters([...filters, id]);
        }
    };

    const onHandleSelectAll = () => {
        if (filters.length === data.length) {
            setFilters([]);
        } else {
            setFilters(data.map((item) => item.id));
        }
    }

    return (
        <div className="immersion_admin__list_table__container immersion_admin__list_table__container__scrollable">
            <table className="immersion_admin__list_table">
                <thead>
                    <tr>
                        {enableFilters && (
                            <th>
                                <Checkbox
                                    name=""
                                    label=""
                                    checked={filters.length === data.length}
                                    onChange={onHandleSelectAll}
                                />
                            </th>
                        )}
                        {columns.map((column, index) => {
                            if (column.identifier === 'id') return null;
                            return (
                                <th key={column.identifier}>
                                    <div className={'display_flex'}>
                                        <button className={`${column.buttonClass ?? ''}`}>
                                            {column.name}
                                            {column?.sort && <SVGIcon src={Icons.ArrowDownUp} color='primary' />}
                                        </button>
                                    </div>
                                </th>
                            )
                        })}
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => {
                        return (
                            <tr
                                key={index}
                            >
                                {enableFilters && (
                                    <td>
                                        <Checkbox
                                            name=""
                                            label=""
                                            checked={isChecked(item.id)}
                                            onChange={() => onHandleFilter(item.id)}
                                        />
                                    </td>
                                )}
                                {keys.map((key, index) => {
                                    if (key !== 'id') {
                                        const column = columns.find((column) => column.identifier === key);
                                        return (
                                            <td key={index}>{column?.render ? column.render(item[key], index) : formatValue(item[key])}</td>
                                        )
                                    }
                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default FilterTable;